import React from "react"
import { ESocialChannel } from "../../lib/Contact/types";
import { IFooterProps } from "./util"
import {
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaYoutube,
    FaLinkedinIn,
    FaVimeo,
    FaPinterest,
    FaTiktok,
} from "react-icons/fa";
import { BackgroundImage } from "../Media";

import ORLogo from "../../static/or-logo.png"

export const FooterLayoutLinks: React.FC<IFooterProps> = ({
    className = "",
    linksGroups,
    linkFunc,
    utilsLinks,
    socialMediaLinks,
    showAttribution,
    backgroundImage,
    bottomTextLines,
    copyright,
}) => {

    const LinkF = linkFunc || ((props) => <a {...props} />);

    return (
        <footer className={`${className} relative w-full`}>
            <div className={`relative w-full mx-auto flex flex-row`}>
                <BackgroundImage
                    className="md:absolute md:left-0 md:w-1/3 lg:w-1/2 md:h-full"
                    src={backgroundImage?.url ?? ""}
                >
                </BackgroundImage>
                <div className="relative w-full flex flex-col">
                    <div className="bg-body-bg-inverted text-body-text-inverted md:self-end w-full md:w-2/3 lg:w-1/2 flex flex-col md:flex-row p-2 md:p-6 lg:p-10 xl:p-14">
                        {linksGroups && linksGroups.map((group, index) => {
                            const links = group.links.map((link, i) => (
                                <dd key={i} className="mb-2">
                                    <LinkF
                                        className="text-sm leading-6 tracking-widest font-semibold text-body-text-inverted hover:text-body-text-inverted"
                                        href={link.url}
                                        target={link.target}
                                    >
                                        {link.text}
                                    </LinkF>
                                </dd>
                            ))
                            return (
                                <dl className="md:mr-6 lg:mr-12 xl:mr-20" key={index}>
                                    <dt className="uppercase tracking-widest leading-9 text-xl pr-5 pb-3.5 mb-5 border-b border-accent font-bold">{group.title}</dt>
                                    {links}
                                </dl>
                            )
                        })}
                    </div>
                    <div className="w-full bg-body-bg">
                        <ul className="list-none flex flex-row justify-center flex-wrap py-6 gap-y-2 uppercase">
                            {utilsLinks && utilsLinks.map((link, index) => (
                                <li className={`px-2 ${index + 1 == utilsLinks.length ? "" : "border-r"}`} key={index}>
                                    <LinkF
                                        className="text-sm leading-6 tracking-widest font-semibold"
                                        href={link.url}
                                        target={link.target}
                                    >
                                        {link.text}
                                    </LinkF>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="bg-body-bg-inverted text-body-text-inverted md:self-end w-full md:w-2/3 lg:w-1/2 flex flex-col md:flex-row items-center p-2 md:p-6 lg:p-10 xl:p-14 gap-y-2 xl:gap-x-20">
                        <div className="flex flex-col items-start">
                            <div className="flex flex-row flex-wrap">
                                {socialMediaLinks &&
                                    socialMediaLinks.map((item, i) => (
                                        <a
                                            key={i}
                                            className="p-3 text-body-text-inverted hover:text-body-text-inverted"
                                            href={`${item.url}`}
                                            title={item.text}
                                            target={item.target}
                                        >
                                            {(() => {
                                                switch (item.channel) {
                                                    case ESocialChannel.Facebook:
                                                        return <FaFacebookF />;
                                                    case ESocialChannel.Twitter:
                                                        return <FaTwitter />;
                                                    case ESocialChannel.Instagram:
                                                        return <FaInstagram />;
                                                    case ESocialChannel.YouTube:
                                                        return <FaYoutube />;
                                                    case ESocialChannel.LinkedIn:
                                                        return <FaLinkedinIn />;
                                                    case ESocialChannel.Vimeo:
                                                        return <FaVimeo />;
                                                    case ESocialChannel.Pinterest:
                                                        return <FaPinterest />;
                                                    case ESocialChannel.TikTok:
                                                        return <FaTiktok />;
                                                    default:
                                                        return null;
                                                }
                                            })()}
                                        </a>
                                    ))}
                            </div>
                            {copyright && (
                                <div className="md:w-56 xl:w-72 text-xs" dangerouslySetInnerHTML={{ __html: copyright }}></div>
                            )}
                        </div>
                        {showAttribution && (
                            <a
                                className="flex flex-row flex-nowrap items-center text-body-text-inverted hover:text-body-text-inverted"
                                href="https://www.organicreturn.com/"
                            >
                                <img className="h-10 w-10" src={ORLogo}></img>
                                <span className="pl-2 w-48 text-xs">Real Estate Website Design, Development and Optimization by Organic Return</span>
                            </a>
                        )}
                    </div>
                </div>
            </div>
            <div className="relative py-5 px-2 text-xs bg-body-bg">
                {bottomTextLines && bottomTextLines.map((item: string, i: number) => (
                    <div key={i} className="w-full mx-auto max-w-screen-2xl pb-1" dangerouslySetInnerHTML={{ __html: item }}>
                    </div>
                ))}
            </div>
        </footer>
    )
}

export default FooterLayoutLinks